export default "__VITE_ASSET__D$looBu9__"